import * as t from 'io-ts';

import {mergeLastWriterWinsValue, RLastWriterWinsValue} from './lastWriterWinsValue';

/*
 * Runtime types.
 */

export const RTemporarilyDismissedId = t.intersection([
  RLastWriterWinsValue,
  t.type({
    isDismissed: t.boolean,
  }),
]);

export const RTemporarilyDismissedIds = t.record(t.string, RTemporarilyDismissedId);

/*
 * Types.
 */

export type TemporarilyDismissedId = t.TypeOf<typeof RTemporarilyDismissedId>;

/*
 * Constants.
 */

export const defaultTemporarilyDismissedIds = {};

/*
 * Merge strategy.
 */

export function mergeTemporarilyDismissedIds(
  left: Record<string, TemporarilyDismissedId>,
  right: Record<string, TemporarilyDismissedId>,
): Record<string, TemporarilyDismissedId> {
  const allKeys = new Set([...Object.keys(left), ...Object.keys(right)]);
  const result: Record<string, TemporarilyDismissedId> = {};

  for (const key of allKeys) {
    const leftValue = left[key];
    const rightValue = right[key];

    if (leftValue && rightValue) {
      result[key] = mergeLastWriterWinsValue(leftValue, rightValue);
    } else {
      result[key] = leftValue ?? rightValue;
    }
  }

  return result;
}
